import { Badge } from "@common/index";
import { ComponentSize } from "@common/types";
import { SubscriptionStatus } from "@models/organization";
import { MEMBERSHIP_STATUS_META } from "./membershipStatus";

interface MembershipStatusBadgeProps {
    status: SubscriptionStatus;
}

export const MembershipStatusBadge = ({
    status,
}: MembershipStatusBadgeProps) => {
    // getMeOrganization (singular) is exported and returns un-normalized data,
    // so there are two fetchers and one normalizer. Fall back rather than
    // destructuring undefined and white-screening the page.
    const { label, color } =
        MEMBERSHIP_STATUS_META[status] ??
        MEMBERSHIP_STATUS_META[SubscriptionStatus.None];

    return (
        <Badge color={color} size={ComponentSize.SM}>
            {label}
        </Badge>
    );
};
